type Breakpoints<T> = { xs: T; m?: T };

export type Video = {
  alt: string;
  aspectRatio?: string;
  autoPlay?: boolean;
  caption?: string;
  loop?: boolean;
  muted?: boolean;
  nativeControls?: boolean;
  poster?: string;
  src?: string;
  audioDescription?: string;
};

interface VideoConfigProps {
  alt: string;
  altPortrait: string;
  audioDescription?: string;
  audioDescriptionPortrait?: string;
  autoPlay: boolean;
  caption?: string;
  captionPortrait?: string;
  loop: boolean;
  muted: boolean;
  videoUrlLargeScreen: string;
  videoUrlSmallScreen: string;
  videoUrlLargeScreenPoster?: string;
  videoUrlSmallScreenPoster?: string;
  isMobile: boolean;
  width?: number;
  height?: number;
  layoutName?: string;
  layoutSize?: string;
  layoutSlot?: string | null;
  useNewAspectRatioBehavior?: boolean;
}

export type VideoPlayerConfig = {
  videos: Partial<Breakpoints<Video>>;
  playsInline: boolean;
  cover?: boolean;
  isFormatable?: boolean;
};

export function getVideoPlayerConfig(props: VideoConfigProps): VideoPlayerConfig {
  const {
    alt,
    altPortrait,
    audioDescription,
    audioDescriptionPortrait,
    autoPlay,
    caption,
    captionPortrait,
    loop,
    muted,
    videoUrlLargeScreen,
    videoUrlSmallScreen,
    videoUrlLargeScreenPoster,
    videoUrlSmallScreenPoster,
    isMobile,
  } = props;

  const activeAlt = isMobile ? altPortrait : alt;
  const activeCaption = isMobile ? captionPortrait : caption;
  const activeAudioDescription = isMobile ? audioDescriptionPortrait : audioDescription;
  const activeAspectRatio = isMobile ? '1/1' : '16/9';
  const activeSrc = isMobile ? videoUrlSmallScreen : videoUrlLargeScreen;
  const activePoster = isMobile ? videoUrlSmallScreenPoster : videoUrlLargeScreenPoster;

  const activeVideo: Video = {
    alt: activeAlt,
    aspectRatio: activeAspectRatio,
    audioDescription: activeAudioDescription,
    autoPlay,
    caption: activeCaption,
    loop,
    muted,
    nativeControls: true,
    src: activeSrc,
    poster: activePoster,
  };

  return {
    cover: true,
    playsInline: true,
    videos: {
      xs: activeVideo,
    },
  };
}
